import { Component, OnInit, ViewChild } from '@angular/core';
import { IdentityService } from 'src/app/@core/services/identity.service';
import { environment } from 'src/environments/environment';
import { CustomCarouselComponent } from 'src/app/shared/components/custom-carousel/custom-carousel.component';
import { LanguageService } from 'src/app/services/language.service';
import { CarouselResize } from 'src/app/shared/models/carousel-resize';
import { LanguageEnum } from 'src/app/shared/models/item.model';
import { TrainingCenterService } from 'src/app/student/services/training.center.service';
import { TrainingCenterModel } from 'src/app/student/models/user.model';

@Component({
  selector: 'app-training-centers',
  templateUrl: './training-centers.component.html',
  styleUrls: ['./training-centers.component.scss']
})
export class TrainingCentersComponent implements OnInit {
  @ViewChild('appCustomCarousel') appCustomCarousel: CustomCarouselComponent<TrainingCenterModel>;
  isRtl: boolean = true;
  mediaUrl: string = environment.mediaUrl;
  carouselResize: CarouselResize<TrainingCenterModel> = {
    data: [],
    items: [],
    itemSizeSm: 1,
    itemSizeMd: 4,
    itemSizeLg: 4,
    itemResize: 0,
    innerWidth: 0,
    currentIndex: 0,
    slideDelay: 15000
  }
  
  constructor(private trainingCenterService:TrainingCenterService, private languageService:LanguageService, private _IdentityService: IdentityService){}

  /** Unified Code mode: tokenised layout (styles/unified-code/components/_home.scss). */
  get isUnified(): boolean {
    return this._IdentityService.isUnifiedCode();
  }
  
  ngOnInit(): void {
    this.isRtl = this.languageService.getCurrentLanguage() === LanguageEnum.ar;
    this.languageService.languageChange.subscribe((result: LanguageEnum) => this.isRtl = result === LanguageEnum.ar);
    this.getTrainingCenters()
  }

  // The paged `/training-center` list is an administrative endpoint and requires a token; the home
  // carousel reads the public projection instead (E2E-ISSUE-049).
  getTrainingCenters(): void {
    this.trainingCenterService.getHomeTrainingCenters().subscribe({
      next: (data: TrainingCenterModel[]) => this.carouselResize.data = data ?? []
    })
  }
}
